module.exports = {"title":"Bahçede","parts":["Oya ödevini yaptı. Pencereden dışarı baktı. Hava çok sıcaktı. Oya bahçeye çıktı. Bahçede kimse yoktu. Oya çok üzüldü. Ayşe ile oynamak istedi.","Oya Ayşe'yi çağırdı. Ayşe bahçeye çıktı. Oya ve Ayşe bahçede koştular, ip atladılar.","Annesi Oya'ya: Eve gel ve yemek ye. dedi. Oya Ayşe'ye: Hoşça kal. dedi. Sonra eve gitti."],"id":"mo_6"}


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/metinokuma/6.json
// module id = ZzXK
// module chunks = 4